import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import { DetailedRecord } from "../../Container";
import { CheckRequests, CreateCheck, CancelCheck } from "./Component";

const ChecksRequestContainer = (props) => {
  const { user, hasPermission, hasRecordPermission } = props;

  return (
    <Router basename="/glc/checks">
      <Switch>
        <Route exact path="/">
          <Redirect to="/list" />
        </Route>
        <Route path="/list">
          <CheckRequests
            user={user}
            hasPermission={hasPermission}
            hasRecordPermission={hasRecordPermission}
          />
        </Route>
        <Route path="/newcheck">
          <CreateCheck user={user} hasPermission={hasPermission} />
        </Route>
        <Route path="/viewCheck">
          <DetailedRecord user={user} hasPermission={hasPermission} />
        </Route>
      </Switch>
    </Router>
  );
};

export default withRouter(ChecksRequestContainer);
